import * as z from "zod";

/** A kind of ticket to a hosted show. Nothing sells them yet. */
export const EventTicketKind = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  /** In `currency`'s minor units. */
  priceCents: z.number(),
  /** The host shop's currency when the kind was made. */
  currency: z.string(),
  /** How many there are; null for no limit. */
  capacity: z.number().nullable(),
  position: z.number(),
});
export type EventTicketKind = z.output<typeof EventTicketKind>;

export const EventTicketKinds = z.object({ kinds: z.array(EventTicketKind) });
export type EventTicketKinds = z.output<typeof EventTicketKinds>;

export interface NewTicketKind {
  name: string;
  description?: string;
  priceCents: number;
  /** Leave it out for no limit. */
  capacity?: number;
}

/** Only what is set changes; `null` clears the description, or lifts the limit. */
export interface TicketKindUpdate {
  name?: string;
  description?: string | null;
  priceCents?: number;
  capacity?: number | null;
}
